import React from 'react';

import { GovernmentInsuranceLink } from './content-primitives';

export default () => (
    <div>
        <span>Online booking for doctors with your insurance isn’t currently available.</span>&nbsp;
        <span>You can research doctors that may accept your insurance here:</span>&nbsp;
        <GovernmentInsuranceLink href="https://www.medicaid.gov/medicaid/by-state/by-state.html">Medicaid</GovernmentInsuranceLink><span>,</span>&nbsp;
        <GovernmentInsuranceLink href="https://www.medicare.gov/physiciancompare/">Medicare</GovernmentInsuranceLink><span>,</span>&nbsp;
        <GovernmentInsuranceLink href="https://tricare.mil/FindDoctor">TRICARE</GovernmentInsuranceLink>
    </div>
);
